import { ErrorDialog } from "@codat/orchard-ui";
import React from "react";

export default function PermissionsErrorDisplay() {
  return (
    <ErrorDialog
      statusCode={403}
      message="You do not have permissions to view this page"
    />
  );
}
